<template>
    <div class="my-font" :style="{ height: height, lineHeight: height }">
        <div
            class="c__header"
            :style="{ height: height, backgroundImage: getBackground }"
        >
            <van-icon
                name="arrow-left"
                class="arrow-left"
                :style="{ lineHeight: height }"
                v-if="isBack"
                v-on:click="goBack"
            />
            {{localTitle}}
        </div>
    </div>
</template>

<script>
import { getCurrentInstance } from "@vue/runtime-core"
import { ellipsisString } from '@/utils/stringUtils'

export default({
    name: 'MyHeader',
    props: {
        title: {
            type: String,
            default: ''
        },
        height: {
            type: String,
            default: '50px'
        },
        isBack: {
            type: Boolean,
            default: false
        },
        isTransparent: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            show: true,
            baseUrl: '/resource/components/',
            imgMap: new Map([
                ['head', 'head.png']
            ])
        }
    },
    created() {
        this.initImg()

        if(/MicroMessenger/i.test(navigator.userAgent)) {
            // ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
            // eslint-disable-next-line no-undef
            wx.miniProgram.getEnv((res)=>{
                if (res.miniprogram) {
                    this.show = false;
                } else {
                    this.show = true;
                }
            })
        }
    },
    methods: {
        initImg() {
            this.imgMap.forEach((value, key) => {
                value = this.baseUrl + value
                this.imgMap.set(key, value)
            });
        },
        goBack() {
            if (window.history.length <= 1 || !window.history.state.back) {
                this.$router.push({path:'/main'})
            } else {
                this.$router.go(-1)
            }
        }
    },
    computed:{
        localTitle() {
            if(this.title && this.title !== '') return ellipsisString(this.title, 20)
            const { proxy } = getCurrentInstance()
            return proxy.$title
        },
        getBackground() {
            return this.isTransparent ? 'none' : 'url(' + this.imgMap.get('head') + ')'
        }
    }
})
</script>

<style scoped>
.c__header {
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 100;
    color: #fff;
    line-height: 50px;
    text-align: center;
    background-size: 100% 200%;
    background-position-y: bottom;
}

.arrow-left {
    position: fixed;
    line-height: 50px;
    left: 10px;
    font-size: 20px;
}

.el-header {
    text-align: center;
    background: #EB3831;
    font-size: 20px;
    color: #FFF;
    line-height: 50px;
}
</style>
